<script setup>
import { useI18n } from 'vue-i18n';

defineProps({
  readiness: { type: Object, default: () => ({ issues: [] }) },
});
const emit = defineEmits(['navigate', 'refresh']);
const { t } = useI18n();
</script>

<template>
  <section class="space-y-3 rounded-xl border border-n-weak bg-n-solid-2 p-4">
    <div class="flex items-center justify-between gap-3">
      <h3 class="text-sm font-semibold text-n-slate-12">
        {{ t('AI_AGENTS.READINESS.TITLE') }}
      </h3>
      <button class="text-sm text-n-teal-11" @click="emit('refresh')">
        {{ t('AI_AGENTS.READINESS.REFRESH') }}
      </button>
    </div>
    <p class="text-xs text-n-slate-11">
      {{ t('AI_AGENTS.READINESS.DESCRIPTION') }}
    </p>
    <ol class="space-y-2">
      <li v-for="(step, index) in readiness.steps || []" :key="step.code">
        <button
          class="flex w-full items-start gap-3 rounded-lg border border-n-weak p-3 text-left"
          @click="emit('navigate', step)"
        >
          <span :class="step.complete ? 'text-n-teal-11' : 'text-n-slate-11'">
            {{ index + 1 }}
          </span>
          <span class="flex-1 text-sm text-n-slate-12">
            {{ t(`AI_AGENTS.READINESS.STEPS.${step.code}.TITLE`) }}
            <span class="mt-1 block text-xs text-n-slate-11">
              {{ t(`AI_AGENTS.READINESS.STEPS.${step.code}.EXAMPLE`) }}
            </span>
          </span>
          <span
            v-if="step.complete"
            class="i-lucide-check size-4 text-n-teal-11"
          />
          <span v-else class="i-lucide-arrow-right size-4 text-n-slate-11" />
        </button>
      </li>
    </ol>
    <p v-if="!readiness.issues?.length" class="text-sm text-n-teal-11">
      {{ t('AI_AGENTS.READINESS.NO_ISSUES') }}
    </p>
    <button
      v-for="issue in readiness.issues"
      :key="`${issue.code}-${issue.node_id || ''}`"
      class="flex w-full items-center justify-between gap-3 rounded-lg border border-n-weak px-3 py-2 text-left text-sm text-n-slate-12 hover:bg-n-alpha-2"
      @click="emit('navigate', issue)"
    >
      {{ t(`AI_AGENTS.READINESS.ISSUES.${issue.code}`) }}
      <span class="i-lucide-arrow-right size-4 shrink-0" />
    </button>
  </section>
</template>
